import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchApplicationDetails, removeApplication } from '../../services/user/ApplicationService';

export const fetchApplicationDetailsAsync = createAsyncThunk(
    'user/fetchApplicationDetails',
    async (groupId: string, thunkAPI) => {
        const response = await fetchApplicationDetails();
        return response;
    }
);

  

  export const removeApplicationAsync = createAsyncThunk(
    'user/removeApplication',
    async (data: any, thunkAPI) => { 
      const response = await removeApplication(data);
      return response;
    }
  ); 